
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/[slug]",
      function () {
        return require("private-next-pages/recipes/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/[slug]"])
      });
    }
  